'use client'

import { Box, styled, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react'
import Calendar from 'react-calendar';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';


import './activity_calendar.css';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

moment.locale('th');

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

const CalendarCustom = styled(Calendar)(({ theme }) => ({
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
    // เพิ่ม CSS สำหรับ tile ที่มี event
    '& .react-calendar__tile--hasEvent': {
        backgroundColor: '#EAF8FF !important',
        color: '#28B0EE !important',
        fontWeight: 'bold',
        borderRadius: '8px',
        '&:hover': {
            backgroundColor: '#D1F2FF !important',
        },
        '&:focus': {
            backgroundColor: '#D1F2FF !important',
        }
    },
    // สำหรับวันที่ถูกเลือกและมี event
    '& .react-calendar__tile--active.react-calendar__tile--hasEvent': {
        backgroundColor: '#28B0EE !important',
        color: 'white !important',
    }
}));

type Props = {
    data: { tfMobileRows: number, startDate: string }[];
    activity_data: { id: number, title: string, start_date: Date | string, end_date: Date | string, address: string, url_file: string }[];
    pagination: {
        page: number;
        limit: number;
        total_item: number;
        set_page: (new_page: number) => void;
        loading?: boolean;
        set_page_limit: (new_limit_page: number) => void;
    }
}

const ActivityCalendar: React.FC<Props> = ({ pagination, activity_data, data }: Props) => {
    const { i18n } = useTranslation();
    const [value, onChange] = useState<Value>(new Date());


    const scrollRef = useRef<HTMLDivElement>(null);
    // INFINITE SCROLL
    const isFetchingRef = useRef(false);
    useEffect(() => {
        const handleScroll = () => {
            const el = scrollRef.current;
            if (!el) return;

            const isBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
            if (isBottom && !isFetchingRef.current) {
                const { page, limit, total_item, set_page } = pagination;
                const maxPage = Math.ceil(total_item / limit);
                if (page < maxPage) {
                    isFetchingRef.current = true;
                    set_page(page + 1);
                    setTimeout(() => {
                        isFetchingRef.current = false;
                    }, 1000);
                }
            }
        };
        const target = scrollRef.current;
        if (target) {
            target.addEventListener("scroll", handleScroll);
        }
        return () => {
            if (target) {
                target.removeEventListener("scroll", handleScroll);
            }
        };
    }, [pagination]);

    return (
        <Box
            data-aos="flip-right"
            sx={{
                backgroundColor: (theme) => theme.palette.background.default
            }} className='w-full grid grid-cols-12 py-10 lg:py-16 gap-4 overflow-hidden h-auto md:gap-[31.5]'>
            <Box component={'section'} className="col-span-12 flex justify-center lg:justify-start h-full">
                <CalendarCustom
                    onChange={onChange}
                    value={value}
                    locale={i18n.language === 'en' ? 'en-GB' : 'th'}
                    sx={{
                        height: "100%",
                    }}
                    showNavigation={true}
                    showDoubleView={false}
                    navigationLabel={({ date, label, locale, view }) => (
                        <Typography sx={{ color: "#000", fontWeight: 'bold', }}>
                            {date.toLocaleDateString(i18n.language === 'en' ? 'en-GB' : 'th-TH', { year: 'numeric', month: 'long' })}
                        </Typography>
                    )}
                    prevLabel={<div className='border-2 p-2 rounded-xl border-slate-400'><ChevronLeft sx={{ color: "#000" }} className="nav-button" /></div>}
                    nextLabel={<div className='border-2 p-2 rounded-xl border-slate-400'><ChevronRight sx={{ color: "#000" }} className="nav-button" /></div>}
                    tileClassName={({ date, view }) => {
                        if (view === 'month') {
                            // เช็คว่า date ตรงกับ startDate ที่ได้จาก data
                            const hasEvent = data.some(event =>
                                moment(date).isSame(moment(event.startDate), 'day')
                            );
                            return hasEvent ? 'react-calendar__tile--hasEvent' : null;
                        }
                        return null;
                    }}
                // ลบ tileContent ออกเพราะไม่ต้องการ indicator เล็กๆ แล้ว
                // tileContent={({ date, view }) => {
                //     if (view === 'month') {
                //         const hasEvent = data.some(event =>
                //             moment(date).isSame(moment(event.startDate), 'day')
                //         );
                //         return hasEvent ? (
                //             <div className="flex justify-center">
                //                 <span className="bg-[#EAF8FF] py-1 px-2 rounded-full text-[#28B0EE] mt-1">
                //                 </span>
                //             </div>
                //         ) : null;
                //     }
                //     return null;
                // }}
                />
            </Box>
        </Box>
    )
}

export default ActivityCalendar